import { Button, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";

import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales";
import { ICustomButtonProps } from "./ICustomButtonProps";

interface ISendButtonProps extends ICustomButtonProps {
  tabIndex?: number;
}

export const SendButton: React.FunctionComponent<ISendButtonProps> = ({
  minimal = true,
  onClick,
  disabled,
  loading,
  intent = Intent.NONE,
  tabIndex,
}) => {
  const { t } = useTl();

  return (
    <Button
      icon={IconNames.SendMessage}
      minimal={minimal}
      onClick={onClick}
      text={minimal ? null : t(ETLCodes.Send)}
      intent={intent}
      loading={loading}
      disabled={disabled}
      tabIndex={tabIndex}
    />
  );
};
